<template>
  <CCardBody>
    <div class="d-flex align-items-center justify-content-between">


      <search-items v-model="search" :searchHandler="searchProduct"></search-items>

      <div class="text-right btngroup">
        <CButton
            class="deleteBtn mr-2"
            @click="exportTemplate"
        >
          Export Prices
        </CButton>
        <CButton v-if="$can('delete-product')"
          class="deleteBtn"
        >
        Delete
        </CButton>
        <router-link class="btn addBtn ml-2" to="/products/add" tag="button" v-if="$can('create-product')">Create</router-link>
      </div>
    </div>


    <b-table
        :items="products"
        :fields="auth_role && auth_role.name !== 'admin' && auth_role.name !== 'MerchantGroupAdmin' ? fields: merchant_fields"
        hover
        sorter
       show-empty
    >
      <template #cell(index)="item">
        {{ item.index + 1 }}
      </template>
      <template #cell(sku_number)="item">
        {{item.item.sku?.sku_number}}
      </template>
      <template #cell(category)="item">
        <h5>{{item.item.categories.map(c => c.category_name).join(', ')}}</h5>
      </template>
      <template #cell(brand)="item">
        <h5>{{item.item.brand?.name}}</h5>
      </template>
      <template #cell(is_private)="item">
        <h5>{{item.item.is_private? 'Yes' : 'No'}}</h5>
      </template>
      <template #cell(is_published)="item" v-if="$can('publish-product')">
        <template v-if="item.item.step_completed == 3 && $can('publish-product')">
          <b-form-checkbox @change="publishProduct($event, item.item.company_id, item.item.id)" :key="item.item.id" :checked="item.item.published" switch></b-form-checkbox>
        </template>
      </template>
      <template #cell(shareable)="item" v-if="$can('product-listing-shareable-column')">
        <template v-if="$can('make-product-shareable')">
          <template v-if="item.item.shareable_info_obj.updating">
            <b-spinner variant="primary" label="Processing"></b-spinner>
            <a @click="reFetchProducts()" class="text-info" style="vertical-align: super;">Processing... refresh</a>
          </template>
          <template v-else-if="item.item.shareable_info_obj.editing">
            <div>
              <b-form-select v-model="item.item.shareable_info_obj.factory" :options="factories" :disabled="item.item.shareable_info_obj.updating" class="col-md-8" />
              <close fillColor="#FF0000" @click="cancelSharableEditing(item.item)" style="cursor:pointer;"/>
              <Check fillColor="#008000" @click="handleProductShareableAction(item.item)" style="cursor:pointer;"/>
            </div>
          </template>
          <span v-else @click="item.item.shareable_info_obj.editing = true" style="cursor: pointer">
            <h5>{{ item.item.shareable_info_obj.factory.name }}</h5>
          </span>
        </template>
        <span v-if="$can('product-listing-factory-name')">
            <h5 >{{ item.item.shareable_info_obj.factory.name }}</h5>
        </span>
      </template>
      <template #cell(actions)="item">
        <edit class="mr-2" v-if="$can('edit-product')" @click="editProduct(item.item.id)" :id="item.item.id" fillColor="#009FE3" />
        <edit class="mr-2" v-if="$can('edit-company-product')" @click="$router.push('/products/update-company-fields/'+item.item.id)" :id="item.item.id" fillColor="#009FE3" />
          <copy v-if="$can('copy-product')" class="mr-2" :id="item.item.id" fillColor="#009FE3"  @click="selectCompany(item.item.id)"/>
        <template v-if="$can('sort-product')">
          <template v-if="pagination.currentPage === 1 && item.index === 0">
            <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                    :disabled="pagination.currentPage === 1 && item.index === 0"
            ><b-icon-arrow-up-short style="font-size: 28px" /></button>
          </template>
          <template v-else>
            <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                    @click.prevent="swapProducts('up',item.index)"
                    :disabled="pagination.currentPage === 1 && item.index === 0"
            ><b-icon-arrow-up-short style="font-size: 28px" /></button>
          </template>
          <template v-if="(pagination.currentPage === pagination.lastPage) && item.index === (products.length - 1)">
            <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                    :disabled="(pagination.currentPage === pagination.lastPage) && item.index === (products.length - 1)"
            ><b-icon-arrow-down-short style="font-size: 28px" /></button>
          </template>
          <template v-else>
            <button class="btn btn-primary btn-sm mr-2" :id="item.item.id"
                    @click.prevent="swapProducts('down',item.index)"
                    :disabled="(pagination.currentPage === pagination.lastPage) && item.index === (products.length - 1)"
            ><b-icon-arrow-down-short style="font-size: 28px" /></button>
          </template>
        </template>

        <template v-if="$can('ecommerce-product-sync') && isEcommercePlatform() ">
          <template v-if="item.item.ecommerceproduct.length < 1">
            <template v-if="item.item.step_completed == 3">
              <button v-if="!sync" @click="syncWithEcommerce(item.item.id)" style="margin-right: 5px">Sync</button>
              <button v-if="sync" type="button" @click="syncProduct(item.item.id)" > Associate </button>
            </template>
          </template>
          <template v-else>
            <button  type="button" @click="dissociateProduct(item.item.id)" > Dissociate </button>
            <button style="margin-left: 5px;"  type="button" @click="syncEcommercePrice(item.item.ecommerceproduct[0].sync_id)" > Sync Price </button>
          </template>
        </template>

        <template v-if="item.item.is_private && $can('assign-private-products')">
          <template v-if="item.item.step_completed == 3">
            <button v-if="item.item.is_private" @click.prevent="assignPrivateProducts(item.item.id,item.item)" style="margin-right: 5px">Assign Private</button>
            <button v-else type="button" @click.prevent="assignPrivateProducts(item.item.id)" > Remove </button>
          </template>
        </template>


      </template>
      <template #empty="">
        No data exists
      </template>
    </b-table>
    <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.rows"
        :per-page="pagination.perPage"
        aria-controls="itemList"
        align="center"
        @change="handlePagination"
        v-if="pagination.total > 0"
        :key="pagination.currentPage"
    ></b-pagination>
    <b-modal id="ecommerceSearchProducts" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Sync Product</span>
      </template>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 my-2">
              <b-form-group id="assign_factory" label-for="assign_factory">

                  <b-input-group prepend="Search Products" class="mt-3">
                    <b-form-input
                        label="ecommerce_search_term"
                        type="text"
                        name="shopify_search_term"
                        v-model="ecommerce_search_term"
                        placeholder="Search products by products title for syncing"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button variant="info" @click="searchEcommerceProducts">Search</b-button>
                    </b-input-group-append>
                  </b-input-group>
               </b-form-group>
                <ul>
                  <li style="padding: 10px" v-for="(ecom_product, index) in ecommerce_search_products" :key="ecom_product.product_id" >
                   <span> <img v-if="ecom_product.product_image" :src="ecom_product.product_image" width="50" height="50" /> </span>
                    <span style="margin-left: 5px">{{ecom_product.product_name}}</span>
                    <span v-if="ecom_product.synced" style="margin-left: 15px"><button @click="clearSyncedProduct(index)" style="background-color: red;">Clear</button></span>
                    <span v-else style="margin-left: 15px"><button @click="selectEcommerceSearchedProduct(index)">Select</button></span>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>

    </b-modal>


    <b-modal id="selectCompanyModel" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Select Company</span>
      </template>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 my-2">
              <b-form-group id="assign_factory" label-for="assign_factory">
                <label class="required"><strong>Copy to Company</strong></label>
                <v-select
                    autocomplete="off"
                    id="company_id"
                    :options="companies"
                    name="company_id"
                    v-model="company"
                    placeholder="Select Company"
                    v-validate="{required: true}">
                </v-select>
                <div v-if="errors && errors.first('company_id')" class="error_msg">
                  Company is required.
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <button class="btn btn-primary"  @click.prevent="submitCompany">Submit</button>
      </template>
    </b-modal>

    <b-modal id="privateProductsAssignment" size="lg" no-close-on-backdrop>
      <template #modal-title>
        <span>Product Assignment</span>
      </template>
      <CCardBody>
        <CRow>
          <CCol v-if="current_product">
            <h1>{{ current_product.product_name }}</h1>
            <template v-for="models in current_product.productmodels">
              <div :key="models.id" style="display: flex;justify-content: space-between">
                <h5>{{models.model_name}}</h5>
                <p>{{models.sku.sku_number}}</p>
              </div>
            </template>
          </CCol>
          <CCol>
            <search
                v-model="customer_search"
                float='right'
                :clickHandler="searchCustomer"
                placeholder="Type to search"
            />
          </CCol>
        </CRow>
        <b-table
            :items="customers"
            :fields="headers"
            hover
            sorter
        >
          <template #cell(image_url)="item">
            <img class="cat_image" :src="base_url+'/'+item.item.image_url">
          </template>
          <template #cell(actions)="item">
            <template>
              <b-form-checkbox @change="removeCustomer(item.item)" v-if="checkIdExists(item.item)" :key="item.item.id" :checked="checkIdExists(item.item)" switch></b-form-checkbox>
              <b-form-checkbox @change="addCustomer(item.item)" v-else  :checked="checkIdExists(item.item)" :key="item.item.id"  name="check-button" switch></b-form-checkbox>
            </template>
          </template>
        </b-table>
        <b-pagination
            v-model="customer_pagination.currentPage"
            :total-rows="customer_pagination.rows"
            :per-page="customer_pagination.perPage"
            aria-controls="itemList"
            align="center"
            @change="handleCustomerPagination"
            v-if="customer_pagination.total > 0"
            :key="customer_pagination.currentPage"
        ></b-pagination>
      </CCardBody>
      <template #modal-footer>
        <button class="btn btn-primary"  @click.prevent="assignProductWithCustomer">Submit</button>
      </template>
    </b-modal>

  </CCardBody>
</template>
<script>
import Edit from 'vue-material-design-icons/Pencil.vue';
import Copy from 'vue-material-design-icons/ContentCopy.vue';
import Close from 'vue-material-design-icons/Close.vue';
import Check from 'vue-material-design-icons/Check.vue';
//import TrayArrowUp from 'vue-material-design-icons/TrayArrowUp';
import "vue-select/dist/vue-select.css";
import SearchItems from "../../components/SearchItems";
import { http } from "@/config/httpCommon"
import {setPageModal, getPageModal, removePageModal, santaClone, isEcommercePlatform} from "@/helpers/Helpers";
// import $ from 'jquery';
  const fields = [
    {key:'index', label:'Sr No'},
    {key: 'product_name', label: 'Product Name'},
    { key: 'sku_number', label: 'SKU No.' },
    { key: 'category', label: 'Category' },
    { key: 'brand', label: 'Brand' },
    { key: 'is_private', label: 'Private' },
    {key: 'is_published', label: 'Published'},
    {key: 'shareable', label: 'Shareable'},
    {key: 'actions'},
  ]

const merchant_fields = [
  {key:'index', label:'Sr No'},
  {key: 'product_name', label: 'Product Name'},
  { key: 'sku_number', label: 'SKU No.' },
  { key: 'category', label: 'Category' },
  { key: 'brand', label: 'Brand' },
  { key: 'is_private', label: 'Private' },
  {key: 'is_published', label: 'Published'},
  {key: 'actions'},
]

  export default {
    components: {
      Edit, Copy, SearchItems, Close, Check
    },
    props: {
      value: File
    },
    name: 'Products',
    data () {
      return {
        switch_on: true,
        switch_off: false,
        text:'',
        company:'',
        companies:[],
        my_group: [],
        checked_groups: [],
        products: [],
        fields,
        merchant_fields,
        categories: [],
        startDate: 1325376000000,
        endDate: 1330560000000,
        modal: false,
        form: {
          product_name: '',
          sku: '',
          offset_x: '',
          slug: '',
        },
        file: null,
        pagination:{
          rows:null,
          currentPage:null,
          perPage:null,
          lastPage:null,
          total:0
        },
        search:'',
        sync:null,
        ecommerce_post_id:null,
        ecommerce_variant_id:null,
        current_product_id:'',
        base_url: process.env.VUE_APP_FILE_URL,
        product_styles:[],
        style_index: '',
        fixed_logo_index: '',
        sides:[
          {id: 'front', label: 'Front'},
          {id: 'back', label: 'Back'},
        ],
        supportsCB:false,
        current_product:{
          product_name:"",
        },
        customer_search:'',
        formStatus:'Update Customer',
        stepModal: false,
        customer_id: 0,
        first_name: '',
        last_name: '',
        email:'',
        password:'',
        role_id:null,
        password_confirmation:'',
        headers: [
          {key: 'first_name', label: 'First Name',},
          {key: 'last_name', label: 'Last Name'},
          {key: 'email', label: 'Email'},
          {key: 'store', label: 'Associated Merchant'},
          {key: 'actions', label: 'Actions',},
        ],
        customers: [],
        customer_pagination:{
          rows:null,
          currentPage:null,
          perPage:null,
          total:0
        },
        customerRoleOptions:[],
        customer_ids:[],
        ecommerce_search_products:[],
        ecommerce_search_term:'',
        move_factory : {
          factoryOptions: [],
          factories:[],
          to_factory_id:null,
          from_factory: null
        },
        factories: [],
        auth_role: {}
      }
    },
    async created() {
      this.auth_role = this.$store.getters.userRole;
      try{
        if(navigator.clipboard) {
          this.supportsCB = true;
        }
        await this.$store.commit('set', ['showLoader', true]);

        let product_modal = getPageModal();
        let page = null;
        let item_for = null;
        if(product_modal && product_modal.page && product_modal.page_name === this.$route.name && product_modal.search){
          page = product_modal.page;
          item_for = product_modal.tab;
          this.current_Tab = product_modal.tab;
          this.search = product_modal.search
          this.searchProduct(page)
        }
        else {
          this.preservePaginationIgnoreSearch('page', 'search', this.$route.name, this.getProducts)
        }
        await this.fetchCompanies()
        await this.getCustomers('')
        await this.$store.commit('set', ['showLoader', false]);

        if(this.$route.query.sync){
          this.sync = this.$route.query.sync
          this.ecommerce_post_id = this.$route.query.post_id
        }
        this.getFactories();
        this.company = this.$store.getters.company;

      }catch(err){
        await this.$store.commit('set', ['showLoader', false]);
        this.showError(err, 'DANGER');
      }
    },
    methods: {
      isEcommercePlatform,
      async reFetchProducts() {
        let query_params = '';
        if(this.search) {
          query_params += `?search=${this.search}`
        }
        if(this.pagination.currentPage) {
          query_params = query_params? query_params + `&page=${this.pagination.currentPage}` : `?page=${this.pagination.currentPage}`
        }
        await this.getProducts(query_params)
        this.showToast('Product list is updated now', 'SUCCESS');
      },
      async getProducts(params){
        await http.get("products"+params).then(successResponse => {
          this.products = successResponse.data.data.data;
          this.factories = successResponse.data.factories;
          this.makePagination(successResponse.data.data);
        }).catch(errorResponse => {
          this.showError(errorResponse)
        });
      },
      makePagination(data){
        this.pagination.currentPage = data.current_page;
        this.pagination.rows = data.total;
        this.pagination.perPage = data.per_page;
        this.pagination.total = data.total;
        this.pagination.lastPage = data.last_page;
      },
      searchProduct(page = 1){
        let params = ''
        if(this.search) {
          params = '?search='+this.search+'&page='+page;
        }
        setPageModal(page,this.$route.name,this.search);
        this.getProducts(params);
      },
      async handlePagination(page=''){

        let params = '?page='+page;
        if(this.search) {
          params += '&search='+this.search
        }
        setPageModal(page,this.$route.name,this.search);
        this.getProducts(params);
      },
      checkbox(){
        console.log(this.checked_groups);
      },
      handleSVG(ev) {
        const file = ev.target.files[0];
        const reader = new FileReader();
        reader.onload = e => {
          this.text = e.target.result;
          // this.getSubGroups(this.text, '');
        };
        reader.readAsText(file);
      },
      editProduct(id){
        this.$router.push('/products/update/'+id);
      },
      syncWithEcommerce(product_id){
        let company = this.$store.getters.company;
        let company_id = company.id;
        let sync_id = `${company_id}${product_id}`;
        if(company.platform == 'wordpress'){
          window.open(
              `${company.company_domains[0]}/wp-admin/edit.php?post_type=product&product_id=${product_id}&sync_id=${sync_id}&company_id=${company_id}`,
              '_blank' // <- This is what makes it open in a new window.
          );
        } else if(company.platform == 'shopify' || company.platform == 'bigcommerce') {
          this.ecommerce_search_products = [];
          this.ecommerce_search_term = '';
          this.current_product_id = product_id;
          this.$bvModal.show('ecommerceSearchProducts');
        }

      },
      async syncProduct(product_id){
        if(this.ecommerce_post_id){
            await this.$store.commit('set', ['showLoader', true]);
            let payload = {product_id, ecommerce_post_id:this.ecommerce_post_id}
            if(this.ecommerce_variant_id)
              payload['ecommerce_variant_id'] = this.ecommerce_variant_id;

            let res = await this.$store.dispatch('syncProduct', payload);
            let res_data = res.data;
            if(res_data.success) {
              this.$router.push('/products');

              this.getProducts('');
              this.sync = null;
              this.showToast(res_data.message, 'SUCCESS');
              this.$bvModal.hide('ecommerceSearchProducts');
              this.ecommerce_post_id = null;
              this.ecommerce_variant_id = null;
            }else{
              this.showToast(res_data.message, 'ERROR');
            }
            await this.$store.commit('set', ['showLoader', false]);

        }else{
          this.showToast('No sync id provided','ERROR')
        }

      },
      async dissociateProduct(product_id) {

          await this.$store.commit('set', ['showLoader', true]);
          let payload = {product_id, ecommerce_post_id:this.ecommerce_post_id, ecommerce_variant_id:this.ecommerce_variant_id}
          let res = await this.$store.dispatch('dissociateProduct', payload);
          let res_data = res.data;
          if(res_data.success) {
            if(this.ecommerce_post_id) {
              this.ecommerce_post_id = null;
              this.ecommerce_variant_id = null;
              this.searchEcommerceProducts();
             }else{
              this.$router.push('/products');
             }
            let params = '';
              this.getProducts(params);
            
            this.showToast(res_data.message, 'SUCCESS');
          }else{
            this.showToast(res_data.message, 'ERROR');
          }
          await this.$store.commit('set', ['showLoader', false]);

      },
      async syncEcommercePrice(sync_id) {

        await this.$store.commit('set', ['showLoader', true]);
        let payload = {sync_id}
        let res = await this.$store.dispatch('syncEcommercePrice', payload);
        if(res) {
          this.showToast('Prices synced successfully', 'SUCCESS');
          await this.$store.commit('set', ['showLoader', false]);
        }
      },
      async searchEcommerceProducts(){

        if(this.ecommerce_search_term.length < 3){
          this.showToast('Please type at least 3 charcters');
        }else{
          this.ecommerce_search_products = [];
          await this.$store.commit('set', ['showLoader', true]);
          let payload = {search_term : this.ecommerce_search_term}
          try{
            let res = await this.$store.dispatch('searchEcommerceProducts', payload);
           this.ecommerce_search_products = res.data;
          }catch (e) {
            this.showToast('No product found','Error');
          }

          await this.$store.commit('set', ['showLoader', false]);
        }
      },
      selectEcommerceSearchedProduct(index){
        let product = this.ecommerce_search_products[index];
        this.ecommerce_post_id = product.product_id;

        if(product.variant_id){
          this.ecommerce_variant_id = product.variant_id
          this.syncProduct(this.current_product_id);
        }else{
          this.showToast('This product not configured correctly on shopify')
        }

      },
      clearSyncedProduct(index){
        let product = this.ecommerce_search_products[index];
        this.ecommerce_post_id = product.product_id;

        if(product.variant_id){
          this.ecommerce_variant_id = product.variant_id
        }
        this.dissociateProduct(this.current_product_id);
      },
      async swapProducts(action, swap_product_index) {
        let self = this;
        let swap_product = self.products[swap_product_index];
        let swap_with_product_index = action == "up" ?  swap_product_index - 1 : swap_product_index + 1;
        let swap_with_product = self.products[swap_with_product_index] ? self.products[swap_with_product_index] : null;
        let query_params =  `?swap_product_id=${swap_product.id}&swap_sort_order=${swap_product.sort_order}`;
        if(swap_with_product) {
          query_params += `&swap_with_product_id=${swap_with_product.id}&swap_with_sort_order=${swap_with_product.sort_order}`
        }
        query_params += `&action=${action}`
        if(self.search) {
          query_params += `&search=${self.search}`;
        }
        query_params += `&page=${self.pagination.currentPage}`

        self.getProducts(query_params);
      },
      selectCompany(product_id){
        this.current_product_id = product_id;
        this.$bvModal.show('selectCompanyModel');
      },
      async fetchCompanies(){
        let res = await this.$store.dispatch('getCompanies');
        this.companies = [];
        if(Object.prototype.hasOwnProperty.call(res,'data') && Object.prototype.hasOwnProperty.call(res.data,'result')){
          res.data.result.forEach(company => {
            this.companies.push({
              id : company.id,
              label:company.company_name
            })
          })
        }
      },
      async submitCompany(){
        let valid = await this.$validator.validate();
        if(valid){
          await this.$store.commit('set', ['showLoader', true]);
          let res = await http.get(`copy-product/${this.company.id}/${this.current_product_id}`);
          if(Object.prototype.hasOwnProperty.call(res,'data') && Object.prototype.hasOwnProperty.call(res.data,'status_code')){
            if(res.data.status_code == 200){
              this.showToast(res.data.message, 'SUCCESS');
              // await this.$store.commit('set', ['showLoader', false]);
              this.$bvModal.hide('selectCompanyModel')
            }
            else{
              this.showToast(res.data.message, 'ERROR');
              // await this.$store.commit('set', ['showLoader', false]);
            }
          }

          await this.$store.commit('set', ['showLoader', false]);

        }
      },
      async publishProduct(published, company_id, product_id){
        let data = {published, company_id, product_id}
        await this.$store.commit('set', ['showLoader', true]);
        await http.post(`publish-product`, data).then(async successResponse => {
          this.showToast(successResponse.data.message, 'SUCCESS');
          await this.$store.commit('set', ['showLoader', false]);
        }).catch(async errorResponse => {
          await this.$store.commit('set', ['showLoader', false]);
          this.showError(errorResponse);
        });

      },
     async assignPrivateProducts(product_id,product){
        this.customer_search = "";
        this.current_product = product;
        this.customer_ids = [];
        // this.resetCustomerPagination();
        await this.getCustomers('',product);
      },
      searchCustomer(search){
        let params = ''
        if(search) {
          search = encodeURIComponent(search)
          params = '?search='+search
        }
        // If we're in the modal context (assigning private products), include product_id
        const product = this.current_product && this.current_product.id ? this.current_product : null;
        this.getCustomers(params, product);
      },
      async getCustomers(params,product=null) {
        // Use current_product if product parameter is not provided but current_product exists
        const productToUse = product || (this.current_product && this.current_product.id ? this.current_product : null);
        
        let productParams = productToUse ? `?product_id=${productToUse.id}` : null;
        let customerParams = params ? params : productParams;
        
        // If params already exist and we have a product, append product_id to params
        if(params && productToUse) {
          const separator = params.includes('?') ? '&' : '?';
          customerParams = `${params}${separator}product_id=${productToUse.id}`;
        }
        
        let res = await this.$store.dispatch("getCustomers", customerParams);
        this.customers = this.$store.getters.getCustomers;
        if(productToUse){
          // Only initialize customer_ids from store on initial load (when array is empty)
          // This happens when assignPrivateProducts is called (which resets customer_ids to [])
          // When paginating or searching, preserve existing customer_ids (user selections)
          const isEmpty = !Array.isArray(this.customer_ids) || this.customer_ids.length === 0;
          if(isEmpty) {
            // Use the store getter which contains customer IDs with the product assigned
            const customersWithProductAssigned = this.$store.getters.getCustomersWithCurrentProductAssigned;
            this.customer_ids = Array.isArray(customersWithProductAssigned) ? [...customersWithProductAssigned] : [];
            // Only show modal on initial load (when product is explicitly passed from assignPrivateProducts)
            if(product) {
              this.$bvModal.show('privateProductsAssignment')
            }
          } else {
            // When paginating or searching, customer_ids are preserved (not overwritten)
          }
          // checkIdExists will check customer_ids to show the current selection state
        }
        
        // this.customers.find(customer => customer);
        this.makeCustomerPagination(res.data);
      },
      async handleCustomerPagination(page=''){
        let params = '?page='+page;
        if(this.customer_search) {
          params += '&search='+this.customer_search
        }
        // If we're in the modal context (assigning private products), include product_id
        const product = this.current_product && this.current_product.id ? this.current_product : null;
        this.getCustomers(params, product);
      },
      makeCustomerPagination(data){
        this.customer_pagination.currentPage = data.meta.current_page;
        this.customer_pagination.rows = data.meta.total;
        this.customer_pagination.perPage = data.meta.per_page;
        this.customer_pagination.total = data.meta.total;
      },
      addCustomer(item){
        // Prevent duplicates and ensure reactivity
        if (!Array.isArray(this.customer_ids)) {
          this.customer_ids = [];
        }
        if (!this.customer_ids.includes(item.id)) {
          this.customer_ids.push(item.id);
        }
      },
      removeCustomer(item){
        // Ensure reactivity by creating a new array
        if (!Array.isArray(this.customer_ids)) {
          this.customer_ids = [];
          return;
        }
        this.customer_ids = this.customer_ids.filter(customer_id => {
          return customer_id !== item.id;
        });
      },
      resetCustomerPagination(){
        this.customer_pagination.rows = null;
        this.customer_pagination.currentPage = null;
        this.customer_pagination.perPage = null;
        this.customer_pagination.total = 0;
      },
      async assignProductWithCustomer(){
        // let valid = await this.$validator.validate();
        // if(valid){8u7y6
          await this.$store.commit('set', ['showLoader', true]);
          // Ensure customer_ids is an array and remove any duplicates
          const customerIds = Array.isArray(this.customer_ids) ? [...new Set(this.customer_ids)] : [];
          let payload = {
              product_id: this.current_product.id,
              customer_ids: customerIds
          };
          let res = await http.post(`assign-product-with-customers`,payload);
          if(Object.prototype.hasOwnProperty.call(res,'data') && Object.prototype.hasOwnProperty.call(res.data,'status_code')){
            if(res.data.status_code == 200){
              this.showToast(res.data.message, 'SUCCESS');
              this.current_product = {};
              this.customer_ids = [];
              // await this.$store.commit('set', ['showLoader', false]);
              this.$bvModal.hide('privateProductsAssignment')
              await this.getCustomers('')
            }
            else{
              this.showToast(res.data.message, 'ERROR');
              // await this.$store.commit('set', ['showLoader', false]);
            }
          }

          await this.$store.commit('set', ['showLoader', false]);

        // }
      },
      checkIdExists(item) {
        // Check customer_ids array which represents user's current selections
        // This persists across pagination and reflects all changes made by the user
        return Array.isArray(this.customer_ids) && this.customer_ids.includes(item.id);
      },
      async getFactories() {
        let res = await this.$store.dispatch("getAllFactories");

        const optionArray = [];
        res.data.map(function (obj) {
          optionArray.push({id: obj.id, label: obj.name});
        })
        this.move_factory.factories = optionArray

      },
      cancelSharableEditing(product) {
        product.shareable_info_obj.editing = false
        product.shareable_info_obj.factory = santaClone(product.shareable_info_obj.previously_selected_factory)
      },
      handleProductShareableAction(product) {
        let shareable_info_obj = product.shareable_info_obj
        let payload = {
          product_id: product.id, move_from_factory_id: shareable_info_obj.previously_selected_factory.id, move_to_factory_id: shareable_info_obj.factory.id
        }
        shareable_info_obj.updating = true
        http.post(`update/product_factory`, payload).then( successResponse => {
          this.showToast(successResponse.data.message, "SUCCESS");
        }).catch( errorResponse => {
          shareable_info_obj.updating = false
          shareable_info_obj.factory = JSON.parse(JSON.stringify(shareable_info_obj.previously_selected_factory))
          this.showToast(errorResponse.response.data.message, 'ERROR');
        });

      },
      exportTemplate() {
        this.$store.commit('set', ['showLoader', true]);
        this.$store.dispatch('exportExcelTemplate').then(() => {
          this.$store.commit('set', ['showLoader', false]);
          this.showToast('Price Lists exported.', 'SUCCESS');
        }).catch((err) => {
          this.$store.commit('set', ['showLoader', false]);
          this.$bvModal.hide('importExcelModal')
          this.showError(err);
        });
      },
    }

  }
</script>
<style lang="scss">
  .hide_file{
    display: none;
  }
  h5{
    margin-bottom: 0;
  }
  p{
    color: #999999;
  }
</style>